import {
  HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { environment } from '../environments/environment';
import { SaveToastService } from './services/save-toast.service';

const MUTATING = new Set(['POST', 'PUT', 'PATCH', 'DELETE']);
const ADMIN_PREFIX = `${environment.apiUrl}/admin/`;

/** POST is also how this API spells list-reads and previews — the same
 *  paths the backend's audit trail skips. */
function isSave(req: HttpRequest<unknown>): boolean {
  if (!MUTATING.has(req.method)) return false;
  if (!req.url.startsWith(ADMIN_PREFIX)) return false;
  const path = req.url.replace(/\/+$/, '');
  return !path.endsWith('/list') && !path.endsWith('/preview');
}

/** Pops the global "Saved" toast on every successful write to the admin
 *  API, whoever triggered it. Failures show nothing here — errors have
 *  their own reporting. */
export function saveToastInterceptor(
  req: HttpRequest<unknown>, next: HttpHandlerFn
): Observable<HttpEvent<unknown>> {
  if (!isSave(req)) return next(req);
  const toast = inject(SaveToastService);
  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse && event.ok) toast.notify();
    })
  );
}
